export const required = (value: string) => {
  return value.trim() !== '' ? null : 'Поле не може бути порожнім';
};

export const emailValidator = (value: string) => {
  const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return pattern.test(value) ? null : 'Неправильний формат адреси';
};

export const minLength = (length: number) => {
  return (value: string) =>
    value.length >= length ? null : `Мінімальна довжина ${length} символів`;
};

export const maxLength = (length: number) => {
  return (value: string) =>
    value.length <= length ? null : `Максимальна довжина ${length} символів`;
};

export const passwordConfirm = (value: string, compareTo: string) => {
  return value === compareTo ? null : 'Паролі не збігаються';
};
